let callCount = 0;
const addImageToContent = () => {
    callCount++;
    setTimeout(() => {
        const puzzle_orientation = document.querySelector('[data-element-code="puzzle_orientation"]');

        if (puzzle_orientation) {
            const items = puzzle_orientation.getElementsByClassName('jtbc-attribute-item__square');
            for (let item of items) {
                let puzzle_orientation_container = item?.parentElement;
                debugger;
                const imageUrl = item.getAttribute('data-texture-url');
                const title = item.getAttribute('data-option-title');

                let img = document.createElement('img');
                img.src = imageUrl;
                //puzzle_orientation.appendChild(img);
                let label = document.createElement('label');
                label.innerHTML = title;
                puzzle_orientation_container.appendChild(label);
            }
        } else {
            addImageToContent();
        }

    }, 1000)
}
//addImageToContent();


const addPlaceHoldersToInputs = () => {
    callCount++;
    setTimeout(() => {
        const items = document.getElementsByClassName('jtbc-input-text-line');

        if (items.length > 0) {
            for (let item of items) {
                const placeHolder = item.getElementsByTagName('label')[0].textContent;
                let textArea = item.getElementsByTagName('textarea')[0];
                if (textArea) {
                    textArea.placeholder = placeHolder;
                }
                let input = item.getElementsByTagName('input')[0];
                if (input) {
                    input.placeholder = placeHolder;
                }

            }
        } else {
            addPlaceHoldersToInputs();
        }

    }, 1000)
}
addPlaceHoldersToInputs();

const toggleEditButton = () => {
    callCount++;
    setTimeout(() => {
        const buttonsContainer = document.querySelector('.jtbc-button-container');
        console.log(buttonsContainer);

        if (items.length > 0) {
            for (let item of items) {
                const placeHolder = item.getElementsByTagName('label')[0].textContent;
                let textArea = item.getElementsByTagName('textarea')[0];
                if (textArea) {
                    textArea.placeholder = placeHolder;
                }
                let input = item.getElementsByTagName('input')[0];
                if (input) {
                    input.placeholder = placeHolder;
                }

            }
        } else {
            addPlaceHoldersToInputs();
        }

    }, 1000)
}

//toggleEditButton();


const onChangeColorPicker = () => {
    setTimeout(() => {
        let color_picker = document.getElementById("colorpicker1");
        if (color_picker) {
            color_picker.onchange = function () {
                color_picker.style.background = color_picker.value;
            }
        } else {
            onChangeColorPicker();
        }
    }, 1000)
}
//onChangeColorPicker();


const moveTabsToPrice = () => {
    setTimeout(() => {
        const container_product_notes = document.querySelectorAll(".jtbc-info-wrapper__desktop .jtbc-product-note");
        const productBlocks = document.querySelectorAll(".product__block--tabs");
        if (container_product_notes.length > 0) {
            let cloneBlocks = [];
            const containerCount = container_product_notes.length;
            const blockCount = productBlocks.length;
            for (let i = 0; i < containerCount; i++) {
                let cloneBlocks = [];
                for (let j = 0; j < blockCount; j++) {
                    cloneBlocks[j] = productBlocks[j].cloneNode(true);
                    container_product_notes[i].appendChild(cloneBlocks[j]);
                }
            }
            for (productBlock of productBlocks) {
                productBlock.style.display = 'none';
            }
        } else {
            moveTabsToPrice();
        }
    }, 1000)
}

moveTabsToPrice();

const moveElementToPrice = () => {
    setTimeout(() => {
        const container_product_notes = document.querySelectorAll(".jtbc-info-wrapper__desktop .jtbc-product-note");
        const productBlocks = document.querySelectorAll("#product-block--sales-point");
        if (container_product_notes.length > 0) {
            let cloneBlocks = [];
            const containerCount = container_product_notes.length;
            const blockCount = productBlocks.length;
            for (let i = 0; i < containerCount; i++) {
                let cloneBlocks = [];
                for (let j = 0; j < blockCount; j++) {
                    cloneBlocks[j] = productBlocks[j].cloneNode(true);
                    container_product_notes[i].appendChild(cloneBlocks[j]);
                }
            }
            for (productBlock of productBlocks) {
                productBlock.style.display = 'none';
            }
        } else {
            moveElementToPrice();
        }
    }, 1000)
}

moveElementToPrice();

const moveMessageAfterTitle = () => {
    setTimeout(() => {
        const productTitle = document.querySelectorAll(".jtbc-product-title");
        console.log(productTitle);
        const productBlocks = document.querySelectorAll(".jtb-section-blocks .product-block--related-product");
         if (productTitle.length > 0) {
            let cloneBlocks = [];
            const titleCount = productTitle.length;
            const blockCount = productBlocks.length;
            for (let i = 0; i < titleCount; i++) {
                let cloneBlocks = [];
                for (let j = 0; j < blockCount; j++) {
                    cloneBlocks[j] = productBlocks[j].cloneNode(true);
                    productTitle[i].after(cloneBlocks[j]);
                }
            }
            for (productBlock of productBlocks) {
                productBlock.style.display = 'none';
            }
        } else {
            moveMessageAfterTitle();
        }
    }, 1000)
}

moveMessageAfterTitle();

const moveMessageAfterButton = () => {
    setTimeout(() => {
        const container_product_notes = document.querySelectorAll(".jtbc-menu-panel");
        const productBlocks = document.querySelectorAll(".social-sharing");
        if (container_product_notes.length > 0) {
            let cloneBlocks = [];
            const containerCount = container_product_notes.length;
            const blockCount = productBlocks.length;
            for (let i = 0; i < containerCount; i++) {
                let cloneBlocks = [];
                for (let j = 0; j < blockCount; j++) {
                    cloneBlocks[j] = productBlocks[j].cloneNode(true);
                    container_product_notes[i].appendChild(cloneBlocks[j]);
                }
            }
            for (productBlock of productBlocks) {
                productBlock.style.display = 'none';
            }
        } else {
            moveElementToPrice();
        }
    }, 1000)
}

moveMessageAfterButton();